import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  CreateFinancialYear,
  DELETE_FINANCIAL_YEAR,
  EDIT_FINANCIAL_YEAR,
  GET_FINANCIALMASTER_BYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import { NewFinancialYearFields } from "./AddFinancialYear.config";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddFinancialMaster = ({
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  onKeyDown,
  isWholePageReload = false,
  showCloseIcon = true,
  showCancelButton = true
}) => {
  let formkey = "Financial_Year";
  const formRef = useRef({});
  const [isFirstLoad, setFirstLoad] = useState(false);

  const [FormData, setFormdata] = useState({});
  const { pushModal, popModal } = useModalContext();
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Financial Year Master");
  const [toggle, settoggle] = useState(show ? show : false);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Financial_Master?.Selected_Row;
  const [selectedRows, setSelectedRows] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState<any>({});
  const dispatch = useDispatch();
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });


  //Q & M
  const [createFinancial_Year, { loading: CreateNewFinancialYear, error }] = useMutation(CreateFinancialYear, {
    onError: (err) => ErrorToast(err.message),
  });

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(GET_FINANCIALMASTER_BYID);

  const [editNewFinancialYear, { loading: EditNewFinancialYear }] = useMutation(EDIT_FINANCIAL_YEAR);

  const [deleteFinancial_Year, { loading: DeleteNewFinancialYear }] = useMutation(DELETE_FINANCIAL_YEAR);

  const FinancialLoadingState =
    CreateNewFinancialYear || EditNewFinancialYear || DeleteNewFinancialYear || GetDataByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    setSelectedRows(fielddataRedux?.Financial_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        const res = { ...data?.Financial_Year };
        res.From_Date = IsoToDateWithoutTime(res.From_Date);
        res.To_Date = IsoToDateWithoutTime(res.To_Date);
        updateValueForm(formRef, res);
        setAllFieldsData(data?.Financial_Year);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(formkey);
    return () => {
      popModal(formkey);
    };
  }, []);

  const submit = async (close: any) => {
    let data: any = FormData;
    console.log(data);
    data = {
      ...data,
      From_Date: data?.From_Date ? convertToISO(data?.From_Date) : "",
      To_Date: data?.To_Date ? convertToISO(data?.To_Date) : "",
    };
    console.log(data, "FInacialdata-redux");
    if (new Date(data.From_Date) >= new Date(data.To_Date)) {
      ErrorToast("From_Date must be before To_Date.");
      return; // Stop execution if the dates are invalid
    }
    if (TypeOfPortal === "Edit") {
      const res = await editNewFinancialYear({
        variables: { id: allFieldsData?._id, userInput: data },
      })
        .then((res) => {
          SuccessToast("Financial Year Master Editted Successfully");
          Closeformfunction();
          dispatch({ type: "Refetch", payload: true });
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else if (TypeOfPortal === "Delete") {
      const ArrayOfID = selectedRows.map((obj: any) => obj._id);
      await deleteFinancial_Year({
        variables: { idsToDelete: ArrayOfID },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Financial Year Master Deleted");
          settoggle(false);
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await createFinancial_Year({
        variables: {
          createInput: data,
        },
      })
        .then((res) => {
          console.log(res, res.errors)
          if (res.errors) {
            ErrorToast("An error occurred: " + res.errors[0].message);
          } else {
            SuccessToast("Financial Year Master Added Successfully");
            if (isWholePageReload) {
              window.location.reload();
            } else {
              dispatch({ type: "Refetch", payload: true });
              if (close === "Close") {
                Closeformfunction();
              }
            }
            setAllFieldsData({});
            dispatch({ type: "ClearData", payload: { data: {} } });
          }
        })
        .catch((err) => {
          // settoggle(toggle);
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  const Closeformfunction = () => {
    popModal(formkey);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
    Closeformfunction();
  };

  if (TypeOfPortal === "Delete Financial Year Master" || modifiedTypeOfPortal === "Delete Financial Year Master") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
      //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={FinancialLoadingState}
        />
      </Reactportal>
    );
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={submit}
      Form_key={formkey}
      submitType={submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : submit}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={FinancialLoadingState}
      showCancelButton={showCancelButton}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          showCloseIcon={showCloseIcon}
          
        >
          <>
            {FinancialLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {NewFinancialYearFields.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        formkey={formkey}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddFinancialMaster;
